import React from 'react'
import GoogleMapReact from 'google-map-react'
import './shared.css'

class KmlMap extends React.Component {
    constructor(props) {
        super(props)
    }

    getMapOptions = (maps) => {
        return {
            mapTypeControl: true,
            mapTypeId: maps.MapTypeId.TERRAIN,
            mapTypeControlOptions: {
                style: maps.MapTypeControlStyle.HORIZONTAL_BAR,
                position: maps.ControlPosition.TOP_CENTER,
                mapTypeIds: [
                    maps.MapTypeId.ROADMAP,
                    maps.MapTypeId.SATELLITE,
                    maps.MapTypeId.HYBRID,
                    maps.MapTypeId.TERRAIN,
                ],
            },
            scaleControl: true,
        }
    }

    handleApiLoaded = (map, maps) => {
        console.log("handleApiLoaded:", this.props.urlKml)
        new maps.KmlLayer({
            url: this.props.urlKml + '?random=' + Math.round(new Date().getTime()),
            map: map,
            suppressInfoWindows: false,
            preserveViewport: false
        });
    }

    render() {
        console.log("rendering KmlMap:", this.props.urlKml)
        return (
            <div className="map-container">
                <GoogleMapReact
                    key={'map_1'}
                    center={[0, 0]}
                    zoom={100000}
                    bootstrapURLKeys={{key: 'AIzaSyDAweNSvuCA2eRhY6edLPMZfezfCSo1bfg'}}
                    yesIWantToUseGoogleMapApiInternals
                    onGoogleApiLoaded={({map, maps}) => this.handleApiLoaded(map, maps)}
                    options={this.getMapOptions}
                />
            </div>
        )
    }
}

export default KmlMap
